/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import QuestionnairesidquestionsquestionIdQuestionnaire from './QuestionnairesidquestionsquestionIdQuestionnaire';

/**
 * The QuestionsQuestionIdBody model module.
 * @module model/QuestionsQuestionIdBody
 * @version v0.3
 */
export default class QuestionsQuestionIdBody {
  /**
   * Constructs a new <code>QuestionsQuestionIdBody</code>.
   * @alias module:model/QuestionsQuestionIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>QuestionsQuestionIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/QuestionsQuestionIdBody} obj Optional instance to populate.
   * @return {module:model/QuestionsQuestionIdBody} The populated <code>QuestionsQuestionIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new QuestionsQuestionIdBody();
      if (data.hasOwnProperty('questionnaire'))
        obj.questionnaire = QuestionnairesidquestionsquestionIdQuestionnaire.constructFromObject(data['questionnaire']);
    }
    return obj;
  }
}

/**
 * @member {module:model/QuestionnairesidquestionsquestionIdQuestionnaire} questionnaire
 */
QuestionsQuestionIdBody.prototype.questionnaire = undefined;

